const mutations = {
    setComparison: (state, payload) => {
        state.store_id = payload.store_id
        state.store_name = payload.store_name
        state.industry_id = payload.industry_id
        state.seat_num = payload.seat_num
        state.date_from = payload.date_from
        state.date_to = payload.date_to
        state.saveStatus = true
    },

    resetComparison(state) {
        state.store_id = null
        state.store_name = null
        state.industry_id = null
        state.seat_num = null
        state.date_from = null
        state.date_to = null
        state.saveStatus = false
        state.isComparison = false
    },

    setChangeStatus(state, payload) {
        state.changeStatus = payload
    },

    setIsComparisonStatus(state, payload) {
        state.isComparison = payload
    }
};

export default mutations;